import React from "react";

import {
  decodeQueryFromURL,
  onTableChangeUpdateUrl,
  onFilterChangeUpdateUrl,
} from "../../utils/list";

export default (
  WrappedComponent,
  defaultValues = {},
  basicColumns = () => [],
  defaultHidden = []
) => {
  return class withParameters extends React.Component {
    constructor(props) {
      super(props);

      this.state = { defaultValues, resize: [], hidden: defaultHidden };
    }

    componentDidMount() {
      const query = decodeQueryFromURL(
        this.props.history,
        this.state.defaultValues
      );

      this.props.loadCache();
      this.props.list(query);
    }

    componentDidUpdate(prevProps) {
      const { history } = this.props;

      if (history.location.search != prevProps.location.search) {
        const query = decodeQueryFromURL(history, this.state.defaultValues);

        this.props.list(query);
      }
    }

    componentWillUnmount() {
      this.props.reset();
    }

    _goBack = () => {
      this.props.history.goBack();
    };

    _setColumns = (cols) => {
      this.setState({ columns: cols });
    };

    _onResize = (col, index) => (e, { size }) => {
      const nextResize = [...this.state.resize];
      nextResize[col] = size.width;
      this.setState({ resize: nextResize });
    };

    _onToggleVisible = (col) => {
      const nextHidden = this.state.hidden;
      const value = nextHidden[col] ? nextHidden[col] : 0;
      nextHidden[col] = value == 0 ? 1 : 0;
      this.setState({ hidden: nextHidden });
    };

    _onFilterChangeUpdateUrl = (form) =>
      onFilterChangeUpdateUrl(this.props.history, form);
    _onTableChangeUpdateUrl = (pagination, filters, sorter) =>
      onTableChangeUpdateUrl(this.props.history, pagination, filters, sorter);

    render() {
      const parameters = decodeQueryFromURL(
        this.props.history,
        this.state.defaultValues
      );
      const columns = basicColumns({
        ...this.props,
        filters: parameters,
        resize: this.state.resize,
        hidden: this.state.hidden,
      });

      return (
        <WrappedComponent
          onPressBack={this._goBack}
          {...this.props}
          columns={columns}
          onResize={this._onResize}
          onToggleVisible={this._onToggleVisible}
          setColumns={this._setColumns}
          filters={parameters}
          onUpdateFilters={this._onFilterChangeUpdateUrl}
          handleTableChange={this._onTableChangeUpdateUrl}
        />
      );
    }
  };
};
